import { API_ENDPOINT } from "@iso/config/index";
import { axiosClient } from "@iso/helpers/axios.config";

const url = `${API_ENDPOINT}/api/identity/roles`;

const groupRoleApi = {
   gets: (params) => {
      return axiosClient.get(url, { params });
   },
   get: (role) => {
      return axiosClient.get(
         `${API_ENDPOINT}/api/permission-management/permissions`,
         {
            params: {
               providerName: "R",
               providerKey: role,
            },
         }
      );
   },
   put: (id, data, params) => {
      return axiosClient.put(
         `${API_ENDPOINT}/api/permission-management/permissions`,
         data,
         { params }
      );
   },
   post: (data) => {
      return axiosClient.post(`${API_ENDPOINT}/api/identity/roles`, data);
   },
   del: (id) => {
      return axiosClient.delete(`${url}/${id}`);
   },
   getRolesByUserId(userId) {
      return axiosClient.get(
         `${API_ENDPOINT}/api/identity/users/${userId}/roles`
      );
   },
   getRoleById(roleId) {
      return axiosClient.get(`${API_ENDPOINT}/api/identity/roles/${roleId}`);
   },
   updateRoleById(roleId, data) {
      return axiosClient.put(`${API_ENDPOINT}/api/identity/roles/${roleId}`, data);
   },
};

export default groupRoleApi;
